import { Routes } from '@angular/router';
import {
  authRoutes,
  detailsRoutes,
  favoritesRoutes,
  formsRoutes,
  homeRoutes,
  lotteryRoutes,
  newsRoutes,
  oddsRoutes,
  staticRoutes,
  trackerRoutes,
} from './routes';
import { Page404Component } from './pages/404/404.component';
// import { WsComponent } from './pages/ws/ws.component';

export const routes: Routes = [
  ...trackerRoutes,
  {
    path: '',
    loadComponent: () => import('./components/layout/layout.component'),
    children: [
      ...authRoutes,
      ...homeRoutes,
      ...detailsRoutes,
      ...favoritesRoutes,
      ...formsRoutes,
      ...newsRoutes,
      ...oddsRoutes,
      ...staticRoutes,
      ...lotteryRoutes,
      {
        path: '404',
        loadComponent: () => Page404Component,
      },
      {
        path: '**',
        redirectTo: '404',
      },
      // {
      //   path: '',
      //   redirectTo: 'Futbol/todos-los-partidos',
      //   pathMatch: 'full',
      // },
      // {
      //   path: ':sport/todos-los-partidos',
      //   loadComponent: () => import('./pages/dashboard/dashboard.component'),
      // },
      // {
      //   path: ':sport/todos-los-partidos/:date',
      //   loadComponent: () => import('./pages/dashboard/dashboard.component'),
      // },
      // {
      //   path: ':sport/match-odds',
      //   component: MatchOddsComponent,
      // },
      // {
      //   path: 'favorites/All',
      //   component: FavoritesComponent,
      // },

      // {
      //   path: 'partido/:sport/:id/:idHome/:idAway/:idCompetition/:date',
      //   component: MatchDetailsComponent,
      // },
      // {
      //   path: 'noticias',
      //   component: NewsComponent,
      // },
      // {
      //   path: 'noticias/:bullet/:channel',
      //   component: NewsComponent,
      // },
      // {
      //   path: 'complaints-book',
      //   component: ClaimBookFormComponent,
      // },
      // {
      //   path: 'contact-us',
      //   component: ContactFormComponent,
      // },
      // {
      //   path: 'contact-us/:iosContact',
      //   component: ContactFormComponent,
      // },
      // {
      //   path: 'politicas-privacidad',
      //   component: TermsPolicyComponent,
      // },
      // {
      //   path: 'condiciones-de-uso',
      //   component: TermsConditionsComponent,
      // },
      // {
      //   path: ':sport/:country/league/:leagueName/:idCompetition',
      //   component: CompetitionDetailsComponent,
      // },
      // {
      //   path: ':sport/:country/team/:teamName/:idTeam',
      //   component: TeamDetailsComponent,
      // },
      // {
      //   path: 'loteriaTorito',
      //   loadComponent: () =>
      //     import('./pages/lottery-torrito/lottery-torrito.component'),
      // },
      // {
      //   path: 'loteriaTorito/:date',
      //   loadComponent: () =>
      //     import('./pages/lottery-torrito/lottery-torrito.component'),
      // },
      // {
      //   path: 'loteriaToritoGanadazo',
      //   component: DashboardComponent,
      // },
      // {
      //   path: 'loteriaToritoMegamillions',
      //   component: DashboardComponent,
      // },
    ],
  },
  // {
  //   path: 'ws',
  //   component: WsComponent,
  // },
];
